<template>
  <v-menu
    v-model="menu"
    :nudge-right="40"
    transition="scale-transition"
    :close-on-content-click="false"
    offset-y
    dense
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="datesView"
        :label="label"
        :filled="filled"
        :disabled="disabled"
        placeholder="Введіть період"
        clearable
        dense
        hide-details
        readonly
        outlined
        @click:clear="clear"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="timestamp"
      no-title
      color="primary"
      locale="uk"
      range
      :min="minValue"
      :max="maxValue"
      dense
      :type="type"
      :allowed-dates="allowedDates"
      outlined
      @change="apply"
    />
  </v-menu>
</template>

<script>
import moment from "moment";
moment.locale("uk");

export default {
  props: {
    label: {
      type: String,
      default: "Період",
    },
    filled: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "date",
    },
    defaultValue: {
      type: Boolean,
      default: false,
    },
    start: {
      type: String,
      default: "",
    },
    end: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    allowedDates: {
      type: Function,
      default: (date) => date,
    },
    maxValue: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    menu: false,
    timestamp: [],
    dateViewFormats: {
      month: "MMMM YYYY",
      date: "DD.MM.YY",
    },
    dateFormats: {
      month: "YYYY-MM",
      date: "YYYY-MM-DD",
    },
  }),
  computed: {
    datesView() {
      const format = this.dateViewFormats[this.type];
      const view = this.timestamp
        .map(t => {
          return moment(t).format(format);
        })
        .join(" ~ ");
      return this.isFullDataSet ? view : "";
    },
    isFullDataSet() {
      return this.timestamp.length > 1 && !this.timestamp.includes("");
    },
    dates() {
      return [this.start, this.end];
    },
    minValue() {
      const [start] = this.timestamp;
      return this.isFullDataSet ? "" : start;
    },
  },
  watch: {
    defaultValue: {
      handler(val) {
        if (val) {
          const format = this.dateFormats[this.type];
          const today = moment().format(format);
          this.timestamp = [today, today];
          this.apply();
        }
      },
      immediate: true,
    },
    dates: {
      handler(val) {
        this.timestamp = val;
      },
      immediate: true,
    },
  },
  methods: {
    apply() {
      const [start, end] = this.timestamp;
      this.$emit("update:start", start);
      this.$emit("update:end", end);
      this.$emit("change");
      this.menu = false;
    },
    clear() {
      this.$emit("update:start", "");
      this.$emit("update:end", "");
      this.$emit("change");
    },
  },
};
</script>